import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "800",
  height: "800",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F35325",
      d: "M1 1h6.5v6.5H1z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#81BC06",
      d: "M8.5 1H15v6.5H8.5z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#05A6F0",
      d: "M1 8.5h6.5V15H1z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFBA08",
      d: "M8.5 8.5H15V15H8.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }